import {Component} from '@angular/core';
import {BaseModalComponent} from "./base_modal.component";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";


@Component({
	selector: 'confirm',
	template: `<base-modal [title]="title" [isLoading]="isLoading" [btnOkClass]="btnOkClass" [btnOkLabel]="btnOkLabel" (onOk)="ok()">
		<ng-content></ng-content>
		<p>{{message}}</p>
	</base-modal>`
})
export class ConfirmComponent extends BaseModalComponent {
	title: string;
	message: string = '';

	constructor(public activeModal: NgbActiveModal) {
		super(activeModal);
	}

	ok() {
		this.activeModal.close(true);
	}
}




